import { DEFAULT_OG_IMAGE, SITE_NAME, SITE_ORIGIN } from './site';

export type SeoRoute = {
  title: string;
  description: string;
  ogTitle?: string;
  h1?: string;
  noindex?: boolean;
};

const DEFAULT_SEO: SeoRoute = {
  title: 'L Benna Production | Photo & Vidéo Mariage Tunis',
  description:
    'Studio photo-vidéo événementiel à Tunis et Djerba depuis 1988. Mariage, photobooth, film corporate et packshot. Devis gratuit sous 24h.',
  h1: 'Photographe & Vidéaste Mariage à Tunis — L Benna Production',
};

const SEO_BY_PATH: Record<string, SeoRoute> = {
  '/': {
    title: 'L Benna Production | Studio Photo, Mariage & Événements en Tunisie',
    description:
      'Studio photo-vidéo à Tunis et Djerba depuis 1988 : mariage, photobooth, impression photo, albums et cadres personnalisés. Production corporate et shooting studio. Devis sous 24h.',
    ogTitle: 'L Benna Production — Studio Photo & Événements en Tunisie',
    h1: 'Impression Photo, Mariage & Cadeaux Personnalisés en Tunisie — L Benna Production',
  },
  '/services': {
    title: 'Services Photo, Vidéo & Événementiel | L Benna',
    description:
      'Prestations photo et vidéo à Tunis et Djerba : mariage, studio, photobooth, corporate et packshot. Studio L Benna Production depuis 1988. Devis gratuit sous 24 h.',
    h1: 'Nos Services Photo, Vidéo & Événementiel',
  },
  '/photobooth': {
    title: 'Location Photobooth Mariage Tunisie | L Benna',
    description:
      'Location photobooth pour mariage et événements en Tunisie. Tirages instantanés, animateur pro et galerie en ligne à Tunis et Djerba. Devis sous 24 h.',
    h1: 'Location Photobooth Mariage en Tunisie',
  },
  '/production': {
    title: 'Production Vidéo Corporate Tunisie | L Benna',
    description:
      'Films corporate, captation événementielle et production vidéo 4K à Tunis, Sfax et Djerba. Montage, étalonnage et livraison rapide. Devis sous 24 h.',
    h1: 'Production Vidéo Corporate en Tunisie',
  },
  '/mariage': {
    title: 'Photographe Mariage Tunis & Djerba | L Benna',
    description:
      'Photographe et vidéaste de mariage à Tunis et Djerba. Reportage photo, film cinématographique, drone et album premium. L Benna Production depuis 1988.',
    h1: 'Photographe et Vidéaste Mariage à Tunis et Djerba',
  },
  '/corporate': {
    title: 'Production Vidéo Corporate Tunisie | L Benna Production',
    description:
      'Films corporate, captation événementielle et production vidéo professionnelle à Tunis et Djerba. Devis sous 24h.',
    h1: 'Production Vidéo Corporate en Tunisie',
  },
  '/portfolio': {
    title: 'Portfolio Photo & Vidéo Tunisie | L Benna Production',
    description:
      'Galerie photo et vidéo L Benna Production : mariages, clips musicaux, corporate et studio à Tunis et Djerba. Découvrez nos réalisations depuis 1988.',
    h1: 'Nos Réalisations Photo & Vidéo',
  },
  '/about': {
    title: 'À Propos — Studio Audiovisuel depuis 1988 | L Benna',
    description:
      'L Benna Production, studio photo-vidéo familial à Tunis et Djerba depuis 1988. Expertise mariage, photobooth, corporate, impression photo et événementiel.',
    h1: 'L Benna Production — Studio Audiovisuel depuis 1988',
  },
  '/contact': {
    title: 'Contact & Devis Photo Vidéo | L Benna Production',
    description:
      'Contactez L Benna Production à Tunis et Djerba pour mariage, photobooth ou film corporate. Réponse garantie sous 24 h par téléphone ou WhatsApp.',
    h1: 'Contactez L Benna Production',
  },
  '/faq': {
    title: 'FAQ Photo, Vidéo & Photobooth Tunisie | L Benna',
    description:
      'Réponses aux questions sur mariage, photobooth, production vidéo corporate et impression photo en Tunisie. L Benna Production — studio depuis 1988.',
    h1: 'Questions fréquentes — L Benna Production',
  },
  '/photographe-mariage-djerba': {
    title: 'Photographe Mariage Djerba | Lbenna Production',
    description:
      'Photographe et vidéaste mariage à Djerba. Reportage photo, film, drone et album premium. Lbenna Production depuis 1988.',
    h1: 'Photographe Mariage à Djerba — Lbenna Production',
  },
  '/photographe-evenement-tunis': {
    title: 'Photographe Événementiel Tunis | L Benna Production',
    description:
      'Photographe événementiel à Tunis : galas, corporate, lancements. Couverture photo professionnelle et livraison rapide.',
    h1: 'Photographe Événementiel à Tunis',
  },
  '/photobooth-djerba': {
    title: 'Location Photobooth Djerba | L Benna Production',
    description:
      'Location photobooth à Djerba pour mariage et soirées. Tirages instantanés, animation et galerie en ligne.',
    h1: 'Location Photobooth à Djerba',
  },
  '/video-corporate-tunisie': {
    title: 'Production Vidéo Corporate Tunisie | Lbenna Production',
    description:
      'Films institutionnels, séminaires et contenus digital pour entreprises en Tunisie. Tournage 4K à Tunis, Sfax, Djerba.',
    h1: 'Production Vidéo Corporate en Tunisie',
  },
  '/portfolio/mariage': {
    title: 'Portfolio Mariage Photo & Vidéo Tunisie | L Benna',
    description:
      'Reportages photo et vidéo de mariage à Tunis et Djerba. Galerie de réalisations L Benna Production : cérémonies, réceptions et albums premium.',
    h1: 'Portfolio Mariage — Reportages Photo & Vidéo',
  },
  '/portfolio/photobooth': {
    title: 'Portfolio Photobooth Mariage & Événements | L Benna',
    description:
      'Galerie photobooth : animations mariage et corporate en Tunisie. Tirages instantanés, fonds personnalisés et galerie en ligne L Benna Production.',
    h1: 'Portfolio Photobooth — Animations & Tirages',
  },
  '/portfolio/corporate': {
    title: 'Portfolio Vidéo Corporate & Événements | L Benna',
    description:
      'Films institutionnels, séminaires et captation événementielle en Tunisie. Découvrez nos réalisations vidéo corporate L Benna Production.',
    h1: 'Portfolio Corporate — Films & Événements',
  },
  '/portfolio/shooting': {
    title: 'Portfolio Shooting Studio & Packshot Tunis | L Benna',
    description:
      'Portraits pro, packshot e-commerce et shootings créatifs en studio à Tunis. Galerie photo L Benna Production — retouche et livraison incluse.',
    h1: 'Portfolio Shooting — Studio & Packshot',
  },
  '/impression-photo-tunis': {
    title: 'Impression Photo Professionnelle à Tunis | L Benna Production',
    description:
      'Impression photo professionnelle à Tunis : tirages mariage, contrecollage, sublimation et livrables studio. L Benna Production depuis 1988.',
    h1: 'Impression Photo Professionnelle à Tunis',
  },
  '/photobooth-tunisie': {
    title: 'Location Photobooth en Tunisie | Mariage & Événements',
    description:
      'Location photobooth en Tunisie pour mariage, corporate et soirées. Tirages instantanés, animateur et galerie en ligne à Tunis et Djerba.',
    h1: 'Location Photobooth en Tunisie — Mariage & Événements',
  },
  '/cadeaux-personnalises-tunis': {
    title: 'Cadeaux Personnalisés Photo à Tunis | L Benna Production',
    description:
      'Cadeaux photo personnalisés à Tunis : tirages, cadres, albums et objets sublimés pour mariages et événements. Studio L Benna Production.',
    h1: 'Cadeaux Personnalisés Photo à Tunis',
  },
  '/album-photo-tunisie': {
    title: 'Album Photo Mariage & Événement en Tunisie | L Benna Production',
    description:
      'Albums photo premium en Tunisie : mariage layflat, coffret cuir, retouche pro. Conception et impression par L Benna Production à Tunis et Djerba.',
    h1: 'Album Photo Mariage & Événement en Tunisie',
  },
  '/cadre-photo-tunisie': {
    title: 'Cadre Photo Personnalisé en Tunisie | L Benna Production',
    description:
      'Cadres photo sur mesure en Tunisie pour mariages et événements. Encadrement professionnel, tirages premium et livraison à Tunis et Djerba.',
    h1: 'Cadre Photo Personnalisé en Tunisie',
  },
  '/blog': {
    title: 'Blog Photo, Vidéo & Mariage Tunisie | L Benna',
    description:
      'Conseils et guides L Benna Production : photobooth mariage, reportage photo, production vidéo et impression photo en Tunisie. Actualités du studio.',
    h1: 'Blog — Conseils Photo & Vidéo en Tunisie',
  },
  '/blog/photobooth-mariage-tunisie': {
    title: 'Photobooth Mariage Tunisie — Guide Complet | L Benna',
    description:
      'Comment choisir un photobooth pour votre mariage en Tunisie : borne premium, tirages, animation et budget. Guide pratique L Benna Production 2026.',
    h1: 'Photobooth mariage en Tunisie : guide complet',
  },
  '/dashboard': {
    title: 'Mon espace client | L Benna Production',
    description: 'Espace client L Benna Production.',
    noindex: true,
  },
};

function normalizePath(pathname: string): string {
  const base = pathname.split('?')[0].split('#')[0] || '/';
  if (base.length > 1 && base.endsWith('/')) return base.slice(0, -1);
  return base;
}

export function getSeoForPath(pathname: string): SeoRoute {
  const path = normalizePath(pathname);

  if (SEO_BY_PATH[path]) return SEO_BY_PATH[path];
  if (path.startsWith('/blog/')) {
    return SEO_BY_PATH[path] ?? {
      title: DEFAULT_SEO.title,
      description: DEFAULT_SEO.description,
      h1: 'Article — L Benna Production',
    };
  }
  if (path.startsWith('/portfolio')) return SEO_BY_PATH['/portfolio'];
  if (path.startsWith('/transfer')) {
    return {
      title: 'Galerie privée | L Benna Production',
      description: 'Accès sécurisé à votre galerie L Benna Production.',
      noindex: true,
    };
  }
  if (path.startsWith('/quotes')) {
    return {
      title: 'Devis | L Benna Production',
      description: 'Consultation de devis L Benna Production.',
      noindex: true,
    };
  }

  return DEFAULT_SEO;
}

export function canonicalUrl(pathname: string): string {
  const path = normalizePath(pathname);
  if (path === '/') return `${SITE_ORIGIN}/`;
  if (SEO_BY_PATH[path] && path.startsWith('/portfolio/')) return `${SITE_ORIGIN}${path}`;
  if (SEO_BY_PATH[path] && path.startsWith('/blog/')) return `${SITE_ORIGIN}${path}`;
  if (path.startsWith('/portfolio?')) return `${SITE_ORIGIN}/portfolio`;
  return `${SITE_ORIGIN}${path}`;
}

export function ogImageUrl(): string {
  return DEFAULT_OG_IMAGE;
}

export function siteName(): string {
  return SITE_NAME;
}
